<!--预加单需求-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="statusList"
          :value.sync="queryParams.internalExternalIs"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
        <global-select
          ref="mainModelSelectRef"
          slot="mainModel"
          :assembleLabel="false"
          :value.sync="queryParams.mainModel"
          selectType="selectSearch"
          requestApi="/scp/scpPreOrderDemandBillResult/mainModelBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="mainModel" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiScpPreOrderDemandBillResultExport" ref="download" />
        <a-button type="primary" :loading="loading" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="handleUpdate">更新数据</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          class="pre-order-demand-table"
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @successCallBack="successCallBack"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1400, extraHeight: 100 }">
          <!--是否停产-->
          <template slot="isStopFlag" slot-scope="text">
            <span>{{ ifObj[text.record.isStopFlag] || '' }}</span>
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!--产能-->
          <span slot="capacitySufficientIsTitle">
            <i class="toRequired">*</i>产能
            <a-icon
              v-if="authObj.GROUP1.capacitySufficientIs"
              class="action-icon"
              @click.stop="onBatchEditData('capacitySufficientIs')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="capacitySufficientIs" slot-scope="text">
            <a-select
              style="width: 100%;"
              :class="{ 'required-css': ruleField.capacitySufficientIs }"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP1.capacitySufficientIs"
              v-model="text.record.capacitySufficientIs"
              allowClear
              @change="checkRequired(text.record, 'capacitySufficientIs')">
              <a-select-option v-for="(item) in capacitySufficientList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
            </a-select>
            <span v-else>{{ text.record.capacitySufficientIsName }}</span>
          </template>
          <!--具体问题描述-->
          <span slot="specificProblemDescriptionTitle">
            具体问题描述
            <a-icon
              v-if="authObj.GROUP1.specificProblemDescription"
              class="action-icon"
              @click.stop="onBatchEditData('specificProblemDescription')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="specificProblemDescription" slot-scope="text">
            <a-input
              :class="{ 'required-input': ruleField.specificProblemDescription }"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP1.specificProblemDescription"
              type="text"
              :maxLength="50"
              v-model="text.record.specificProblemDescription"
              @blur="checkRequired(text.record, 'specificProblemDescription')" />
            <span v-else>{{ text.record.specificProblemDescription }}</span>
          </template>
          <!--产能解决方案-->
          <span slot="capacitySolutionsTitle">
            产能解决方案
            <a-icon
              v-if="authObj.GROUP1.capacitySolutions"
              class="action-icon"
              @click.stop="onBatchEditData('capacitySolutions')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="capacitySolutions" slot-scope="text">
            <a-input
              :class="{ 'required-input': ruleField.capacitySolutions }"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP1.capacitySolutions"
              type="text"
              :maxLength="50"
              v-model="text.record.capacitySolutions"
              @blur="checkRequired(text.record, 'capacitySolutions')" />
            <span v-else>{{ text.record.capacitySolutions }}</span>
          </template>
          <!--瓶颈物料-->
          <span slot="bottleneckMaterialsTitle">
            瓶颈物料
            <a-icon
              v-if="authObj.GROUP2.bottleneckMaterials"
              class="action-icon"
              @click.stop="onBatchEditData('bottleneckMaterials')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="bottleneckMaterials" slot-scope="text">
            <global-select
              class="select-material"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP2.bottleneckMaterials"
              v-model="text.record.bottleneckMaterials"
              selectType="selectFilter"
              :focusGet="true"
              :dropdown-match-select-width="false"
              requestApi="/scp/scpMrpSystemItems/planItemsBox"
              :selectItem="{ value: 'selectedValue', label: 'label' }"
              :setParams="{ organizationCode: 'A001' }"
              searchParam="label"
              sourseField="res"
              :totalNum="9999999999"
              @change="(val) => changeBottleneckMaterial(val, text.record)"
            />
            <span v-else>{{ text.record.bottleneckMaterialsName ? (text.record.bottleneckMaterials + '-' + text.record.bottleneckMaterialsName) : '' }}</span>
          </template>
          <!--压缩采购周期-->
          <span slot="compressPurchaseCycleTitle">
            <i class="toRequired">*</i>压缩采购周期
            <a-icon
              v-if="authObj.GROUP2.compressPurchaseCycle"
              class="action-icon"
              @click.stop="onBatchEditData('compressPurchaseCycle')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="compressPurchaseCycle" slot-scope="text">
            <a-input-number
              :class="{ 'required-input': ruleField.compressPurchaseCycle }"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP2.compressPurchaseCycle"
              class="num-input"
              :min="0"
              :max="9999999999"
              v-model="text.record.compressPurchaseCycle"
              :formatter="value => `${value}`.replace(/^(\d*).*$/, '$1')"
              :parser="value => `${value}`.replace(/^(\d*).*$/, '$1')"
              @blur="checkRequired(text.record, 'compressPurchaseCycle')" />
            <span v-else>{{ text.record.compressPurchaseCycle }}</span>
          </template>
          <!--已备料情况/物料解决方案-->
          <span slot="remarkTitle">
            已备料情况/物料解决方案
            <a-icon v-if="authObj.GROUP2.remark" class="action-icon" @click.stop="onBatchEditData('remark')" type="edit" title="编辑"/>
          </span>
          <template slot="remark" slot-scope="text">
            <a-input
              v-if="isEdit && currentId === text.record.id && authObj.GROUP2.remark"
              type="text"
              :maxLength="50"
              v-model="text.record.remark" />
            <span v-else>{{ text.record.remark }}</span>
          </template>
          <!--最晚确认时间-->
          <span slot="latestConfirmTimeTitle">
            <i class="toRequired">*</i>最晚确认时间
            <a-icon
              v-if="authObj.GROUP3.latestConfirmTime"
              class="action-icon"
              @click.stop="onBatchEditData('latestConfirmTime')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="latestConfirmTime" slot-scope="text">
            <a-date-picker
              :class="{ 'required-css': ruleField.latestConfirmTime }"
              v-if="isEdit && currentId === text.record.id && authObj.GROUP3.latestConfirmTime"
              v-model="text.record.latestConfirmTime"
              valueFormat="YYYY-MM-DD"
              @change="checkRequired(text.record, 'latestConfirmTime')"
              :disabled-date="disabledEndDate" />
            <span v-else>{{ text.record.latestConfirmTime && $moment(text.record.latestConfirmTime).format('YYYY-MM-DD') }}</span>
          </template>
          <!--备注（供应策略方案）-->
          <span slot="supplyStrategyProposalTitle">
            备注(供应策略方案)
            <a-icon
              v-if="authObj.GROUP3.supplyStrategyProposal"
              class="action-icon"
              @click.stop="onBatchEditData('supplyStrategyProposal')"
              type="edit"
              title="编辑"/>
          </span>
          <template slot="supplyStrategyProposal" slot-scope="text">
            <a-input
              v-if="isEdit && currentId === text.record.id && authObj.GROUP3.supplyStrategyProposal"
              type="text"
              :maxLength="50"
              v-model="text.record.supplyStrategyProposal" />
            <span v-else>{{ text.record.supplyStrategyProposal }}</span>
          </template>
          <!--需求/备料提前天数-->
          <template slot="advanceDays" slot-scope="text">
            <span>{{ Number(text.record.lockDay || 0) + Number(text.record.compressPurchaseCycle || 0) }}</span>
          </template>
          <!--动态月-->
          <template v-for="item in dateFiledList" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div class="month-data" :key="'pre-order-demand-val-'+item.dataIndex">
              {{ record[item.dataIndex] }}
              <span v-if="record.previous[item.dataIndex] < 0" class="data-item down">{{ record.previous[item.dataIndex] }}</span>
              <span v-if="record.previous[item.dataIndex] > 0" class="data-item update">+{{ record.previous[item.dataIndex] }}</span>
            </div>
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
          <template slot="footer">
            <StickyFixedSummary
              ref="summaryRef"
              :footerTableColumns="footerTableColumns"
              :columns="columns"
              :dateFiledList="dateFiledList" />
          </template>
        </ls-api-table>
      </div>
      <BatchEditModal ref="BatchEditModalRef" @onRefresh="handleOk" :capacitySufficientList="capacitySufficientList" />
    </template>
  </ls-table-layout>
</template>

<script>
import {
  apiScpPreOrderDemandBillResultEdit,
  apiScpPreOrderDemandBillResultList,
  apiScpPreOrderDemandBillResultUpdateData,
  apiScpPreOrderDemandBillResultExport,
  scpPreOrderDemandBillDatesListByYear,
  apiScpPreOrderDemandStaticsSum
} from '@/api/scp/pre-order-and-placement/pre-order-and-placement'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import BatchEditModal from '@/views/scp/producingAndMarketing/pre-order-demand/components/batch-edit-modal'
import cloneDeep from 'lodash.clonedeep'
import StickyFixedSummary from '@/components/StickyFixedSummary'
import moment from 'moment'
import { mapState } from 'vuex'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  // eslint-disable-next-line
  name: 'Pre-order-demand',
  components: { DownloadModal, BatchEditModal, StickyFixedSummary },
  mixins: [ cacheRequest ],
  computed: {
    ...mapState({
      name: (state) => state.user.name,
      jobCode: (state) => state.user.jobCode
    }),
    columns() {
      return [
        { title: '事业部', dataIndex: 'businessTeamName', align: 'center', width: 100, ellipsis: true, stickyFixed: 'left' },
        { title: '项目组', dataIndex: 'projectTeam', align: 'center', width: 85, stickyFixed: 'left' },
        { title: '物料编码', dataIndex: 'materialNo', align: 'center', width: 100, stickyFixed: 'left' },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 80, stickyFixed: 'left' },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 120, ellipsis: true, stickyFixed: 'left' },
        { title: '主型号', dataIndex: 'mainModel', align: 'center', width: 70, stickyFixed: 'left' },
        { title: '研发分类', dataIndex: 'developType', align: 'center', width: 80, stickyFixed: 'left' },
        { title: '是否停产', dataIndex: 'isStopFlag', align: 'center', width: 80, scopedSlots: { customRender: 'isStopFlag' } },
        { title: '下单类别', dataIndex: 'orderType', align: 'center', width: 80 },
        { title: '销售类目', dataIndex: 'salesCategory', align: 'center', width: 80 },
        { title: '平均采购价', dataIndex: 'averagePurchasePrice', align: 'center', width: 90 },
        { title: '锁定期', dataIndex: 'lockDay', align: 'center', width: 80 },
        { title: '预计确认需求时间', dataIndex: 'expectDeterminDemandDate', align: 'center', width: 120 },
        ...this.dateFiledList,
        { title: 'M+3月预测数量', dataIndex: 'forecastQtyM3', align: 'center', width: 120 },
        { title: 'M+2月预测数量', dataIndex: 'forecastQtyM2', align: 'center', width: 120 },
        { title: 'M+1月预测数量', dataIndex: 'forecastQtyM1', align: 'center', width: 120 },
        { title: '负责计划员', dataIndex: 'planUserName', align: 'center', width: 100 },
        { title: '负责原材采购', dataIndex: 'rawMaterialPurchaseUser', align: 'center', width: 110 },
        { title: '内部/外部', dataIndex: 'internalExternalIs', align: 'center', width: 90 },
        { title: '供应商', dataIndex: 'supplier', align: 'center', width: 100, ellipsis: true },
        {
          // title: '产能',
          dataIndex: 'capacitySufficientIs',
          scopedSlots: { customRender: 'capacitySufficientIs', title: "capacitySufficientIsTitle" },
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          // title: '具体问题描述',
          dataIndex: 'specificProblemDescription',
          align: 'center',
          scopedSlots: { customRender: 'specificProblemDescription', title: "specificProblemDescriptionTitle" },
          width: 140
        },
        {
          // title: '产能解决方案',
          dataIndex: 'capacitySolutions',
          align: 'center',
          scopedSlots: { customRender: 'capacitySolutions', title: "capacitySolutionsTitle" },
          width: 140
        },
        {
          // title: '瓶颈物料',
          dataIndex: 'bottleneckMaterials',
          align: 'center',
          scopedSlots: { customRender: 'bottleneckMaterials', title: "bottleneckMaterialsTitle" },
          width: 200
        },
        { title: '正常采购周期', dataIndex: 'purchasingLeadTime', align: 'center', width: 120 },
        {
          // title: '压缩采购周期',
          dataIndex: 'compressPurchaseCycle',
          scopedSlots: { customRender: 'compressPurchaseCycle', title: "compressPurchaseCycleTitle" },
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          // title: '已备料情况/物料解决方案',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark', title: "remarkTitle" },
          align: 'center',
          width: 190,
          ellipsis: true
        },
        { title: '需求/备料提前天数', dataIndex: 'advanceDays', scopedSlots: { customRender: 'advanceDays' }, align: 'center', width: 140 },
        {
          // title: '最晚确认时间',
          dataIndex: 'latestConfirmTime',
          scopedSlots: { customRender: 'latestConfirmTime', title: "latestConfirmTimeTitle" },
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          // title: '备注(供应策略方案)',
          dataIndex: 'supplyStrategyProposal',
          scopedSlots: { customRender: 'supplyStrategyProposal', title: "supplyStrategyProposalTitle" },
          align: 'center',
          width: 180,
          ellipsis: true
        },
        { title: '来源单据号', dataIndex: 'sourceCode', align: 'center', width: 165 },
        { title: '提报年份', dataIndex: 'year', align: 'center', width: 90, ellipsis: true },
        { title: '提交人', dataIndex: 'submitUserName', align: 'center', width: 80, ellipsis: true },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 80, ellipsis: true },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 150, scopedSlots: { customRender: 'dateFormat' } },
        { title: '操作', width: 90, dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, stickyFixed: 'right' }
      ]
    },
    footerTableColumns () {
      return [
        {
          title: '勾选',
          align: 'center',
          width: 60,
          stickyFixed: 'left'
        },
        ...this.columns
      ]
    }
  },
  data() {
    return {
      ifObj: { 'N': '否', 'Y': '是' },
      dateFiledList: [], // 日期列表部分
      dateObj: {}, // 字段
      isEdit: false,
      loading: false,
      currentId: "",
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      statusList: [], // 状态
      capacitySufficientList: [], // 产能
      permissionList: [], // 权限接口
      apiScpPreOrderDemandBillResultExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpPreOrderDemandBillResultList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        projectTeam: undefined,
        businessTeamName: undefined,
        materialNo: undefined,
        mainModel: undefined,
        internalExternalIs: undefined,
        itemName: undefined,
        foldNumber: undefined
      },
      organizationList: [], // 需求组织数据
      // 表格数据
      tableList: [],
      formList: [
        { label: '物料编码', decorator: ['materialNo'], type: 'input' },
        { label: '项目组', decorator: ['projectTeam'], type: 'input' },
        { label: '内外部情况', decorator: ['internalExternalIs'], type: 'statusList' },
        { label: '事业部', decorator: ['businessTeamName'], type: 'input' },
        { label: '主型号', decorator: ['mainModel'], type: 'mainModel' },
        { label: '物料名称', decorator: ['itemName'], type: 'input' }
      ],
      originRequired: ['capacitySufficientIs', 'specificProblemDescription', 'capacitySolutions', 'latestConfirmTime', 'compressPurchaseCycle'], // 必填字段
      requiredList: [], // 权限下的必填字段
      ruleField: {
        capacitySufficientIs: false, // 产能
        specificProblemDescription: false, // 具体问题描述
        capacitySolutions: false, // 产能解决方案
        latestConfirmTime: false, // 最晚确认时间
        compressPurchaseCycle: false // 压缩采购周期
      },
      // 是否有编辑权限
      authObj: {}
    }
  },
  created() {
    this.initAuth()
    this.initDate()
    // 内外部情况
    this.cacheLookupRequest('SCP_FG_SUPPLY_TYPE', { lookupType: 'SCP_FG_SUPPLY_TYPE', current: 1, pageSize: 999 }, 'statusList')
    // 产能
    this.cacheLookupRequest('SCP_CAPACITY_SUFFICIENT', { lookupType: 'SCP_CAPACITY_SUFFICIENT', current: 1, pageSize: 999 }, 'capacitySufficientList')
    this.getLookupList('SCP_PRE_ORDER_EDIT_PERMISSION', 'permissionList') // 权限
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 翻页清除选择
    successCallBack() {
      this.isEdit = false
      this.currentId = '';
      if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 批量编辑数据
    onBatchEditData(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field)
    },
    // 更新数据
    handleUpdate() {
      this.loading = true;
      apiScpPreOrderDemandBillResultUpdateData({}).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(e => {
        this.loading = false;
      })
    },
    // 校验字段是否必填
    checkRequired(data, field) {
      // 当产能为不足时，要校验具体问题描述、产能解决方案为必填
      if (field === 'specificProblemDescription' || field === 'capacitySolutions') {
        this.ruleField[field] = data.capacitySufficientIs === 'SHORTAGE' && (data[field] === undefined || data[field] === '' || data[field] === null)
      } else {
        this.ruleField[field] = data[field] === undefined || data[field] === '' || data[field] === null
      }
    },
    // 编辑
    handleEdit(record) {
      let hasAuth = false; // 是否有权限标识
      ['GROUP1', 'GROUP2', 'GROUP3'].forEach(group => {
        if (this.authObj[group]) {
          const authList = Object.values(this.authObj[group])
          if (authList.includes(true)) { hasAuth = true }
        }
      })
      if (!hasAuth) {
        this.$message.warning('编辑无权限')
        return;
      }
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      // 必填初始化
      this.ruleField = {
        capacitySufficientIs: false, // 产能
        specificProblemDescription: false, // 具体问题描述
        capacitySolutions: false, // 产能解决方案
        latestConfirmTime: false, // 最晚确认时间
        compressPurchaseCycle: false // 压缩采购周期
      }
      this.isEdit = true;
      this.currentId = cloneDeep(record.id);
    },
    // 初始化获取动态日期
    initDate() {
      scpPreOrderDemandBillDatesListByYear({}).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) {
            this.initSetDate(res.data)
            this.$nextTick(() => {
              if (this.$refs?.dataTable) this.$refs.summaryRef.initSet(this.$refs.dataTable)
            })
          }
        } else {
          this.$message.error(res?.msg)
        }
      })
    },
    // 设置日期
    initSetDate(data) {
      this.dateFiledList = []
      this.dateObj = {}
      data.forEach(item => {
        this.dateFiledList.push({ dataIndex: `date${item.dateSeq}`, title: item.dateDisplay, width: 120, align: 'center', scopedSlots: { customRender: `date${item.dateSeq}` } })
        this.dateObj[`date${item.dateSeq}`] = null
      })
    },
    // 瓶颈物料非必填，特殊处理undefined入参接口会丢失问题
    changeBottleneckMaterial(val, data) {
      if (val === undefined) { data.bottleneckMaterials = '' }
    },
    // 保存
    handleSave(data) {
      let requiredFlag = false; // 是否有必填项未填
      this.requiredList.forEach((field) => {
        this.checkRequired(data, field)
        if (this.ruleField[field]) {
          requiredFlag = true
        }
      })
      if (requiredFlag) {
        this.$message.warning('必填项不能为空！')
        return
      }
      this.loading = true;
      apiScpPreOrderDemandBillResultEdit({ ...data }).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false;
          this.currentId = '';
          this.onSearch()
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(e => {
        this.loading = false;
      })
    },
    handleCancel() {
      this.isEdit = false;
      this.currentId = '';
    },
    // 通用查快码
    getLookupList (type, arr) {
      this[arr] = []
      const lookupQueryParams = { lookupType: type, current: 1, pageSize: 999 }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows?.length > 0) {
          this[arr] = response.rows
          if(arr === 'permissionList') {
            this.checkAuth() // 检查权限并赋值
          }
        }
      })
    },
    // 初始化权限
    initAuth() {
      this.requiredList = []; // 先清空权限相关的必填字段
      this.authObj = {
        GROUP1: {
          capacitySufficientIs: false, // 产能
          specificProblemDescription: false, // 具体问题描述
          capacitySolutions: false // 产能解决方案
        },
        GROUP2: {
          bottleneckMaterials: false, // 瓶颈物料
          compressPurchaseCycle: false, // 压缩采购周期
          remark: false // 备注
        },
        GROUP3: {
          latestConfirmTime: false, // 最晚确认时间
          supplyStrategyProposal: false // 供应策略方案
        }
      }
    },
    // 检查权限 lookupCode为分组字段；attribute2为已授权的工号字段；attribute1为权限字段（GROUP，现在快码就配置了这三组）
    checkAuth() {
      if (this.permissionList?.length > 0) {
        ['GROUP1', 'GROUP2', 'GROUP3'].forEach(group => {
          const getItem = this.permissionList?.find(v => v.lookupCode === group)
          if (getItem && getItem?.attribute2) {
            const authCodes = getItem.attribute2?.split(',') || [];
            if (authCodes?.includes(this.jobCode) && getItem.attribute1) {
              const fields = getItem.attribute1?.split(',') || [];
              fields.forEach(field => {
                this.$set(this.authObj[group], field, true)
                // 处理必填，判断允许编辑前提下，是否存在必填字段
                if (this.originRequired.includes(field) && this.authObj[group][field]) {
                  this.requiredList.push(field)
                }
              })
            }
          }
        })
      }
    },
    // 表单搜索
    onSearch(value = {}) {
      this.isEdit = false
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      if (this.$refs?.summaryRef) this.$refs.summaryRef.summaryFromApi(cloneDeep(params), apiScpPreOrderDemandStaticsSum)
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        projectTeam: undefined,
        businessTeamName: undefined,
        materialNo: undefined,
        mainModel: undefined,
        internalExternalIs: undefined,
        itemName: undefined,
        foldNumber: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      this.$refs.mainModelSelectRef.handleSearch(''); // 重新查询主型号下拉
    },
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    },
    // 导出(存在动态列，不能走下载列表)
    handleExport() {
      this.$message.loading({ content: '导出中...' })
      this.downloadByJson('scp/scpPreOrderDemandBillResult/export', this.$refs.dataTable.searchParams, `预加单需求导出_${moment().format('YYYY-MM-DD')}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../../components/StickyFixedSummary/styles/footerTable.less';
.pre-order-demand-table{
  /deep/ .ant-table-tbody tr td {
    padding: 8px 8px;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 12px 8px;
  }
}
.required-css{
  /deep/ .ant-select-selection{
    border: 1px solid red;
  }
  /deep/ .ant-input{
    border: 1px solid red;
  }
}
.required-input{
  border: 1px solid red;
}
.select-material{
  /deep/ .ant-select{
    width: 100%
  }
}
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
.month-data{
  position: relative;
  .data-item{
    position: absolute;
    right: 0;
    top: -15px;
    font-weight: 700;
  }
  .down{
    color: red;
  }
  .update{
    color: green;
  }
}
</style>
